
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.111","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"グループ 204"}},[_c('path',{attrs:{"data-name":"パス 258","d":"M.306 21.695V.306h11.183l5.317 5.317v16.072z","fill":"#fff"}}),_c('g',{attrs:{"data-name":"グループ 203"}},[_c('path',{attrs:{"data-name":"パス 259","d":"M11.367.611L16.5 5.744v15.645H.611V.611h10.756M11.611 0H0v22h17.111V5.5l-5.5-5.5z","fill":"#c74343"}})])]),_c('g',{attrs:{"data-name":"グループ 206"}},[_c('path',{attrs:{"data-name":"パス 260","d":"M11.306 5.806v-5.5h.183l5.317 5.317v.183z","fill":"#ffd9d9"}}),_c('g',{attrs:{"data-name":"グループ 205"}},[_c('path',{attrs:{"data-name":"パス 261","d":"M11.611.856L16.256 5.5h-4.645V.856m0-.856H11v6.111h6.111V5.5l-5.5-5.5z","fill":"#c74343"}})])]),_c('path',{attrs:{"data-name":"パス 262","d":"M4.4 17.111a.688.688 0 01-.733-.611c0-.856 1.1-1.528 2.506-2.017a17.44 17.44 0 001.589-3.606 6.589 6.589 0 01-.55-2.322 1.529 1.529 0 01.183-.794.751.751 0 01.672-.428.672.672 0 01.611.367 1.323 1.323 0 01.122.733 10.54 10.54 0 01-.428 2.322 11.927 11.927 0 001.711 2.811 6.13 6.13 0 012.506.122c.611.183.733.55.733.794s-.122.856-1.161.856a3.379 3.379 0 01-2.383-1.222 18.561 18.561 0 00-3.3.672c-.55 1.406-1.405 2.323-2.078 2.323zm-.122-.611H4.4c.306 0 .794-.428 1.283-1.161-.856.367-1.406.794-1.406 1.161zm6.478-2.261a2.432 2.432 0 001.528.672c.55 0 .55-.183.55-.244 0-.122-.244-.183-.306-.244a3.853 3.853 0 00-1.772-.184zm-2.628-2.567a18.314 18.314 0 01-1.1 2.506c.794-.183 1.589-.367 2.322-.489a16.046 16.046 0 01-1.222-2.017zm0-3.728c-.061 0-.122 0-.122.061-.061.061-.061.183-.061.489a5.387 5.387 0 00.183 1.283 5.854 5.854 0 00.183-1.344 2.312 2.312 0 00-.061-.489z","fill":"#c74343"}})])
          )
        }
      }
    